import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { collection, query, where, onSnapshot, limit, orderBy } from 'firebase/firestore';
import { db } from '../firebase-client';
import WalletAddress from './WalletAddress';
import { useFlips } from '../hooks/useFlips';
import Button from './Button';
import Link from 'next/link';

dayjs.extend(relativeTime);

const q = query(collection(db, process.env.NEXT_PUBLIC_FLIP_WALLET_COLLECTION), limit(10), orderBy('createdAt', 'desc'));

function FlipsFeed() {
  const { tokenChoices } = useFlips();
  const [flips, setFlips] = useState([]);

  useEffect(() => {
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const flips = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setFlips(flips);
    });

    // unsubscribe from the listener when the component unmounts
    return () => unsubscribe();
  }, []);

  return (
    <div className='max-w-2xl mx-auto w-full mt-10'>
      <div className='rounded-lg bg-gray-900 p-2 md:p-8 max-h-[350px] overflow-y-scroll'>
        <ul>
          {flips.map((flip) => (
            <FlipsFeedItem flip={flip} key={flip.id} />
          ))}
        </ul>
      </div>

      <div className='flex justify-center mt-6'>
        <Button link href='/flips/stats' theme='outline'>
          View Stats
        </Button>
      </div>
    </div>
  );
}

function FlipsFeedItem({ flip }) {
  const { getChoiceOfTokenName } = useFlips();

  return (
    <li className='flex md:flex-row gap-1 flex-col justify-between odd:bg-gray-800 p-3 rounded-lg text-sm'>
      <p className='text-gray-400'>
        <Link href={`/profile/${flip.address}`}>
          <a className='text-white'>
            <strong>
              <WalletAddress address={flip.address} />
            </strong>
          </a>
        </Link>{' '}
        flipped for{' '}
        <span className='text-white font-medium'>
          {flip.betAmount} {getChoiceOfTokenName(flip.choiceOfToken)}
        </span>{' '}
        and{' '}
        {flip.didWin ? (
          <a href={`https://allo.info/tx/${flip.prizeTxnId}`} className={'text-green-400 font-medium'} target={'_blank'}>
            doubled
          </a>
        ) : (
          <span className={'text-red-400 font-medium'}>lost</span>
        )}
        .
      </p>
      <p className='text-gray-400'>{dayjs(flip.createdAt.toDate()).fromNow()}</p>
    </li>
  );
}

export default FlipsFeed;
